import {
  Box,
  Card,
  CrudMode,
  DataDisplay,
  Grid,
  InfoBanner,
  pn,
  Stack,
  Typography,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { Select } from "components";
import { LkRoleId, User, UserEditResource, UserViewResource } from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';

export const UserRole = (props: {
  crudMode: CrudMode;
  user: User;
  appUserRoleId: number | undefined;
  userMembership: string;
  reroute?: (userMembership: string, crudMode: CrudMode) => void;
  setUser: (value: User) => void;
  viewResource: UserViewResource;
  editResource: UserEditResource;
  validationErrors: ValidationErrors | string[];
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const userRoleField = () => {
    var propertyName = pn<User>("roleId");
    var property = properties.find((x) => x.propertyName === propertyName);

    return (props.crudMode === "view" || (props.appUserRoleId != LkRoleId.Cobro && props.appUserRoleId != LkRoleId.Administrator)) ? (
      <DataDisplay label={property?.displayName}>{props.user.role?.name}</DataDisplay>
    ) : (
      <Select
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.editResource.roles?.find((x) => x.id === props.user.roleId)}
        options={props.editResource.roles}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setUser(
            produce(props.user, (draft) => {
              draft.roleId = value?.id;
            })
          )
        }
        renderOption={(props, option) => (
          <Box component="li" {...props}>
            <Stack>
              <Box>{option.name}</Box>
              <Typography variant="caption">{option.description}</Typography>
            </Stack>
          </Box>
        )}
      />
    );
  };

  return (
    <Card header={
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <GroupOutlinedIcon></GroupOutlinedIcon>
          <Typography variant="inherit" paddingLeft={"5px"}>Role</Typography>
        </Stack>
      </Stack>
    } fullHeight>
      <Grid ref={breakpointsRef} container spacing="sm" direction="column">
        <Grid item xs={smallFieldBreakpoints} paddingBottom="30px">
          {userRoleField()}
        </Grid>
        <InfoBanner title="">
          <Typography variant="caption" color="primary">{props.user.role?.description}</Typography>
        </InfoBanner>
      </Grid>
    </Card>
  );
};
